import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type AppealSmall = {
  created_at: string;
  id: string;
  status: string;
  updated_at: string;
};

export type AdminAppealTebleData = {
  merchant_amount?: number;
  merchant_amount_usdt?: number;
  open_order_amount?: number;
  open_order_amount_usdt?: number;
  check_image_links: string[];
  created_at: string;
  id: string;
  merchant_email: string;
  order_amount: number;
  order_amount_usdt: number;
  order_invid: string;
  order_type: string;
  order_uuid: string;
  status: string;
  trader_email: string;
  updated_at: string;
};

export type AdminAppealResponse = {
  current_appeal: AdminAppealTebleData;
  merchant_email: string;
  order_checker_message: string;
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_invid: string;
  order_old_status: string;
  order_start_amount: number;
  order_start_amount_usdt: number;
  order_type: string;
  order_uuid: string;
  previous_appeals?: AppealSmall[];
  trader_email: string;

  platform_approve?: boolean;
  platform_decided_at?: string;
  platform_decision_amount?: number;
  platform_decision_reason?: string;
};

export type AdminAppelsResponse = PaginationResponse<{
  order_appeals: AdminAppealResponse[];
  total_count: number;
}>;

export type AdminAppealRequest = PaginationParameters & {
  status?: string;
  order_uuid?: string;
  email?: string;
  sort_desc?: string;
};

export const getAdminAppealsApi = async (data?: AdminAppealRequest) => {
  try {
    const queryParams = getQueryParams(data);
    const response = await fetchData<AdminAppelsResponse>({
      url: `api/v1/admin/appeals?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getAdminAppealsApi failed:", error);
    throw error;
  }
};

export type AdminAppealUpdateSumRequest = {
  new_sum: number;
  reason: string;
};

export const updateOrderSumApi = async (
  order_uuid: string,
  data: AdminAppealUpdateSumRequest
) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/orders/${order_uuid}/update-sum`,
      method: "PUT",
      data,
    });

    return response;
  } catch (error) {
    console.error("updateOrderSum failed:", error);
    throw error;
  }
};

export type AdminAppealUpdateStatusRequest = {
  approve: boolean;
  actual_received_amount?: number;
};

export type AdminAppealUpdateStatusResponse = {
  amount: number;
  error: string;
  processed: boolean;
  status: string;
};

export const updateOrderStatusApi = async (
  appeal_id: string,
  data: AdminAppealUpdateStatusRequest
) => {
  try {
    const response = await fetchData<AdminAppealUpdateStatusResponse>({
      url: `api/v1/orders/appeals/${appeal_id}/process`,
      method: "POST",
      data,
    });

    return response;
  } catch (error) {
    console.error("updateOrderStatus failed:", error);
    throw error;
  }
};

export type PriceHistory = {
  changed_at: string;
  changed_by: string;
  previous_amount: number;
  previous_amount_usdt: number;
  reason: string;
};

export type AdminOrderExtended = {
  agent_plus_merchant_commission?: number;
  assigned_to_trader_time?: string;
  account_transfer?: boolean;
  bank: string;
  closed_time?: string;
  created_at: string;
  currency: string;
  device_name?: string;
  exchange_rate: number;
  for_different_platform?: boolean;
  free?: boolean;
  invid: string;
  merchant_spend_rub?: number;
  merchant_spend_usdt?: number;
  method: "sbp";
  order_final_amount: number;
  order_final_amount_usdt: number;
  order_old_status?: string;
  order_start_amount: number;
  order_start_amount_usdt: number;
  // operation?: string;
  order_type?: string;
  requisite?: string;
  status: string;
  trader_files?: string[];
  trader_message?: string;
  type_confirm: string;
  price_history?: PriceHistory[];

  // sbp?: boolean;
  updated_at: string;
  uuid: string;
};

type AdminAppealModalData = {
  actual_received_amount?: number;
  card_number: string;
  check_image_links: string[];
  created_at: string;
  cardholder_name?: string;
  id: string;
  message: string;
  order_type: string;
  status: string;
  timeout?: number;
  updated_at: string;
};

export type AdminOrderAndAppeals = {
  appeals: AdminAppealModalData[];
  merchant_email: string;
  trader_email: string;
  order: AdminOrderExtended;
};

export const getOrderAndAppealsApi = async (order_id: string) => {
  try {
    const response = await fetchData<AdminOrderAndAppeals>({
      url: `api/v1/admin/orders/${order_id}/appeals`,
    });

    return response;
  } catch (error) {
    console.error("getOrderAndAppealsApi failed:", error);
    throw error;
  }
};
